import React from 'react';

const HeroB = ({
  titulo = "¿Cómo funciona?",
  items = ["aaa", "aa"],
  imagen,
  parrafo,
  botonTexto,
  invertir,
}) => {
  return (
    <section className="w-full bg-[#E8F2F4] flex justify-center py-10 px-4 sm:px-6">
      <div
        className={`bg-[#0346A4] w-full max-w-6xl flex flex-col ${
          invertir ? "lg:flex-row-reverse" : "lg:flex-row"
        } items-center justify-between gap-10 px-6 sm:px-10 lg:px-16 py-10 lg:py-16 relative z-10 rounded-3xl`}
      >
        <div
          className={`text-white w-full lg:w-auto ${
            invertir ? "lg:pl-12" : ""
          }`}
        >
          <h2
            className="text-3xl sm:text-4xl font-extrabold mb-6 drop-shadow"
            style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.4)" }}
          >
            {titulo}
          </h2>
          {parrafo ? (
            <p
              className="text-base sm:text-lg font-medium mb-6 leading-relaxed"
              style={{ textShadow: "1px 1px 3px rgba(0, 0, 0, 0.4)" }}
            >
              {parrafo}
            </p>
          ) : (
            <ul className="space-y-4 mb-6">
              {items.map((item, idx) => (
                <li
                  key={idx}
                  className="flex items-center gap-3 text-lg sm:text-xl font-bold"
                >
                  <span className="text-2xl sm:text-3xl">⚙️</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          )}
          {botonTexto && (
            <button className="w-full bg-[#276AE8] text-white font-bold py-3 rounded-full shadow-md hover:bg-[#3689ff] transition text-sm md:text-base">
              {botonTexto}
            </button>
          )}
        </div>
        <div
          className={`w-full ${
            invertir ? "lg:w-2/5" : "lg:w-3/5"
          } flex justify-center lg:justify-end`}
        >
          <img
            src={imagen}
            alt="Imagen sección"
            className="rounded-2xl w-full max-w-xl h-64 sm:h-80 lg:h-[500px] object-cover shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroB;
